var React = require('react');

function CaretSolidInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.820002 1.80043C4.47968 3.54317 7.41802 6.50626 9.13 10.1804C10.8448 6.5082 13.7823 3.54593 17.44 1.80043L16.82 0.44043C13.5599 2.14152 10.8822 4.7775 9.13 8.01043C8.84131 7.41866 8.50697 6.85027 8.13 6.31043C6.39903 3.8529 4.10966 1.84113 1.45 0.440429L0.820002 1.80043Z","fill":"black"}));
}

CaretSolidInline.defaultProps = {"width":"18","height":"11","viewBox":"0 0 18 11","fill":"none"};

module.exports = CaretSolidInline;

CaretSolidInline.default = CaretSolidInline;
